"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageInfo = void 0;
const Photo_1 = require("./Photo");
class ImageInfo {
    constructor(id, uploadId, name, photo, created, updated) {
        this.name = "";
        this.id = id;
        this.uploadId = uploadId;
        this.name = name;
        this.photo = photo;
        this.created = created;
        this.updated = updated;
    }
    static fromDto(imageInfoDto) {
        return new ImageInfo(imageInfoDto.id, imageInfoDto.uploadId, imageInfoDto.name ? imageInfoDto.name : "", Photo_1.Photo.fromDto(imageInfoDto.photo), imageInfoDto.created, imageInfoDto.updated);
    }
}
exports.ImageInfo = ImageInfo;
